import { z } from 'zod';
import { globalSearchSchema } from 'src/modules/shared/schemas/search.schema';

export const reportsSearchSchema = globalSearchSchema
  .extend({
    phoneVersion: globalSearchSchema.shape.phoneVersion.default('v1' as const),
  })
  .merge(
    z.object({
      tab: z.enum(['basic', 'advanced']).default('basic'),
    })
  );

export type ReportsSearch = z.infer<typeof reportsSearchSchema>;
